var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'features-container': true,
    'cols5': _vm.cols ? _vm.cols === 5 : false,
    'cols3': _vm.cols ? _vm.cols === 3 : false,
    'cols2': _vm.cols ? _vm.cols === 2 : false,
    'l-spacing': _vm.spacing ? _vm.spacing === 'l' : false
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }